import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=62335ffb&scoped=true&"
import script from "./Column.vue?vue&type=script&lang=ts&"
export * from "./Column.vue?vue&type=script&lang=ts&"
import style0 from "./Column.vue?vue&type=style&index=0&id=62335ffb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62335ffb",
  null
  
)

export default component.exports